import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { useEffect } from "react";

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="container mx-auto px-4 py-24 max-w-4xl">
        <h1 className="font-display text-4xl md:text-5xl font-bold mb-8 text-center">
          Terms & <span className="text-gradient">Conditions</span>
        </h1>
        
        <div className="space-y-8 text-muted-foreground">
          <section className="bg-card/50 p-8 rounded-2xl border border-border/50 backdrop-blur-sm">
            <h2 className="font-display text-2xl font-semibold text-foreground mb-4">TICKETS</h2>
            <div className="space-y-4">
              <p>
                Tickets are issued subject to the terms and conditions set out below. The passenger, by purchasing a ticket, confirms that he/she accepts and understands the terms and conditions and that he/she is aware of all conditions of carriage of the bus services.
              </p>
              <p>Tickets are not transferable.</p>
              <p>
                Passengers must ensure that all the information is correct when purchasing a ticket. Any alteration to a ticket will render it invalid.
              </p>
              <p>Right of admission reserved.</p>
            </div>
          </section>

          <section className="bg-card/50 p-8 rounded-2xl border border-border/50 backdrop-blur-sm">
            <h2 className="font-display text-2xl font-semibold text-foreground mb-4">DEPARTURE TIME</h2>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>Passengers are requested to be at the boarding location at least 30 minutes before departure.</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>Booked seats which are not filled 5 minutes before departure will be offered to stand-by passengers on a first come first serve basis.</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>Any changes in the schedule will be communicated to passengers.</p>
              </div>
            </div>
          </section>

          <section className="bg-card/50 p-8 rounded-2xl border border-border/50 backdrop-blur-sm">
            <h2 className="font-display text-2xl font-semibold text-foreground mb-4">SMOKING AND ALCOHOL</h2>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>Strictly no use of any illegal substances, consumption of alcohol or smoking on the bus.</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>We have the right to refuse to service or load any passenger under the influence of alcohol or any illegal substance.</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>Any person found in breach of our terms and conditions regarding the consumption of alcohol or smoking will be disembarked immediately at the next safe area.</p>
              </div>
            </div>
          </section>

          <section className="bg-card/50 p-8 rounded-2xl border border-border/50 backdrop-blur-sm">
            <h2 className="font-display text-2xl font-semibold text-foreground mb-4">PETS</h2>
            <p>No pets will be allowed on the vehicle, with the exception of trained guide dogs accompanying a blind person.</p>
          </section>

          <section className="bg-card/50 p-8 rounded-2xl border border-border/50 backdrop-blur-sm">
            <h2 className="font-display text-2xl font-semibold text-foreground mb-4">LUGGAGE</h2>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>Any luggage will be transported at the owner's risk.</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>No refund will be provided for any lost or damaged luggage.</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>Passengers are allowed to carry 20kg of luggage for free.</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>For luggage sending services, a minimum charge applies from 1 kilogram.</p>
              </div>
            </div>
          </section>

          <section className="bg-card/50 p-8 rounded-2xl border border-border/50 backdrop-blur-sm">
            <h2 className="font-display text-2xl font-semibold text-foreground mb-4">FARE</h2>
            <p>Fares can change anytime without notice. Ticket prices may vary based on date / place of purchase.</p>
          </section>

          <section className="bg-card/50 p-8 rounded-2xl border border-border/50 backdrop-blur-sm">
            <h2 className="font-display text-2xl font-semibold text-foreground mb-4">REFUND / RE-BOOKINGS</h2>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>Tickets that are refunded may incur a 50% penalty fee.</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>Rebooking a ticket must be requested 24 hours before departure / earlier.</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>Re-booking will only be allowed once per ticket.</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>When re-booking a ticket, a penalty fee may be applied and cannot be refunded.</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>No refund / re-booking will be allowed 2 hours prior or after the scheduled departure time.</p>
              </div>
            </div>
          </section>

          <section className="bg-card/50 p-8 rounded-2xl border border-border/50 backdrop-blur-sm">
            <h2 className="font-display text-2xl font-semibold text-foreground mb-4">CHILDREN</h2>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>No children under the age of 12 years will be allowed to travel without an accompanying adult.</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>Children under the age of 3 years travel for free if not occupying a seat.</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                <p>Should more than one child under the age of 3 travel, accompanied by the same adult, the passenger is required to purchase one extra ticket at the applicable rate.</p>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
